import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  DeleteApiLoginMutationResponse,
  DeleteApiLogin401,
  DeleteApiLogin403,
} from "../../../types/DeleteApiLogin";

export function getDeleteApiLoginUrl() {
  return `/api/Login` as const;
}

/**
 * {@link /api/Login}
 */
export async function deleteApiLogin(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    DeleteApiLoginMutationResponse,
    ResponseErrorConfig<DeleteApiLogin401 | DeleteApiLogin403>,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiLoginUrl().toString(),
    ...requestConfig,
  });
  return res;
}
